import { NextPageContext } from 'next';
import { KnownCookies } from '@sls-react/typings/cookies';
import { parseCookies } from 'nookies';
import { parse } from 'cookie';
import decodeJwt from '@sls-react/utils/decodeJwt';

export default function decodeCookieJwt(context?: NextPageContext) {
  let accessToken: string | undefined;
  if (context?.req) {
    const parsedCookies: KnownCookies =
      context.req?.['cookies'] || parseCookies(context);
    accessToken = parsedCookies.access_token;
  } else if (typeof document !== 'undefined') {
    const cookies: KnownCookies = parse(document.cookie);
    accessToken = cookies.access_token;
  }
  if (accessToken) {
    return decodeJwt(accessToken);
  }

  return null;
}
